<div class="flex justify-content-center align-items-center h-full"
     [ngStyle]="{ transform: 'rotate(' + rotation() + 'deg)' }">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.75 5.75L5.75 0.75M5.75 5.75V0.75H0.75" [attr.stroke]="stroke()" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>
